import { Component, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { QuickLoanService } from "../services/quickLoan.service";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ViewChild } from "@angular/core";
import { MatTableExporterDirective } from "mat-table-exporter";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "src/app/_LOS/services/los.service";
import { DatePipe } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";
declare var $: any;
import { DialogService } from "src/app/Shared/dialog.service";

@Component({
  selector: "app-quickloan-long-form-website-data",
  templateUrl: "./quickloan-long-form-website-data.component.html",
  styleUrls: ["./quickloan-long-form-website-data.component.scss"],
})
export class QuickloanLongFormWebsiteDataComponent implements OnInit {
  DateFrom: any = new Date();
  today: Date = new Date();
  showSpinner: boolean = false;
  DateTo: any = new Date();
  SelectStatus: any = "";
  currentUser: any;
  dataSourceDetail: MatTableDataSource<any>;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  public get dialog(): DialogService {
    return this._dialog;
  }
  displayedColumnsPanAadhar: string[];
  rowData: any = null;
  dataSourceAadharPan: any;
  displayedDetailColumns: string[];
  LoanProduct_Id: string = "";
  ProductList: any[] = [];
  NetFinance_Amt: any;
  customerId: any;
  Category: any;
  ExistLoan: any;
  selectedRow: any;
  IsWebsiteFrequencyOpen: boolean = false;
  showFinancialDetails = false;
  InterestAmount: any;
  ROI: any;
  Days: any;
  AgreementAmount: any;
  areaData: any[] = [];
  BranchesList: any[] = [];
  BranchName: Object;
  datePipe: DatePipe = new DatePipe("en-US");
  SalesExecutiveData: any;
  CollectionExecutiveData: Object;
  Branch_Id: string = "";
  SelectSourceArea: string = "";
  LoanMaturityDate: any;
  Loan_Date: any = new Date();
  Reason: any;
  EMI_Type: any = "";
  No_Of_Inst: any;
  // profile pic varaibles
  profilePicString: string = "";
  parts: string[];
  base64Contentprofileimage: string;
  profileimageName: string;
  // aadhar front variables
  aadharFrontString: string = "";
  base64ContentAadharFront: string;
  aadharFrontImageName: string;
  //aadhar back variables
  aadharBackString: string = "";
  base64ContentAadharBack: string;
  aadharBackImageName: string;
  //pan card variables
  panCardString: string = "";
  base64ContentPanCard: string;
  panCardImageName: string;
  // EmploymentProofDocument variables
  EmploymentProofDocumentString: string = "";
  base64ContentEmploymentProofDocument: string;
  EmploymentProofDocumentImageName: string;
  // BankStatement variables
  BankStatementString: string = "";
  base64ContentBankStatement: string;
  BankStatementImageName: string;
  // salary slip variables
  salarySlipFiles: { salarybase64: string; salaryfileName: string }[] = [];
  salarySlipString: string = "";
  salarySlipNames: string = '';
  ReasonStatus: any;
  ROW: any;
  docModalTitle: string = '';
  docModalBase64: string = '';
  docModalFileName: string = '';
  docModalType: 'image' | 'pdf' = 'image';
  pdfSrc: any = '';
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTableExporterDirective, { static: false })
  exporter: MatTableExporterDirective;
  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private _QuickLoanService: QuickLoanService,
    private _MasterService: MasterService,
    private LmsService: LmsService,
    private losService: LosService,
    private _dialog: DialogService,
    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Long Form");
    this.getProductDropdown();
    this.getBranchesList();
  }
  getFullAddress(element: any): string {
    return [
      element.address1,
      element.address2,
      element.landmark,
      element.area,
      element.district,
      element.state,
      element.pinCode,
    ]
      .filter(Boolean)
      .join(", ");
  }
  getBranchesList() {
    this.LmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe(
      (result: any) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
        console.log("Branch List", this.BranchesList);
        this.BranchName = result.Branch_Name;
        console.log("Branch Name", this.BranchName);
      }
    );
  }
  getProductDropdown() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result: any) => {
        this.IsWebsiteFrequencyOpen = result[0].IsWebsiteFrequencyOpen;
        if (!this.IsWebsiteFrequencyOpen) {
          this.ProductList = JSON.parse(
            JSON.stringify(
              result.filter((x) => x.Category == "Single Installment")
            )
          );
        } else {
          this.ProductList = JSON.parse(
            JSON.stringify(
              result.filter((x) => x.ProductCatId == 2)
            )
          );
        }
        // console.log(this.ProductList)
      });
  }
  openDocModal(title: string, base64: string, fileName: string) {
    this.docModalTitle = title;
    this.docModalBase64 = base64;
    this.docModalFileName = fileName;

    // Detect PDF by file extension
    const isPdf = fileName?.toLowerCase().endsWith('.pdf') ||
      title.toLowerCase().includes('pdf') ||
      title.toLowerCase().includes('statement') ||
      title.toLowerCase().includes('employment proof');

    if (isPdf) {
      this.docModalType = 'pdf';
      // Convert base64 to a safe resource URL for iframe
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + base64);
    } else {
      this.docModalType = 'image';
      this.pdfSrc = '';
    }

    $('#docViewModal').modal('show');
    $('#docViewModal').css('z-index', '1060');
  }
  closeDocModal() {
    $('#docViewModal').modal('hide');
    this.docModalTitle = '';
    this.docModalBase64 = '';
    this.docModalFileName = '';
  }
  getLongFormWebsiteData() {
    this.showSpinner = true;
    let fromDate = new Date(this.DateFrom);
    fromDate.setHours(0, 1, 0, 0);
    let toDate = new Date(this.DateTo);
    this._QuickLoanService
      .LongFormWebsiteData({ from: fromDate, to: toDate, status: this.SelectStatus, })
      .subscribe((res: any[]) => {
        if (res && res.length > 0) {
          this.displayedDetailColumns = [
            "id",
            "name",
            "fatherName",
            "mobileNo",
            "address",
            "loanAmount",
            "createdAt",
            "updatedAt",
            "status",
            "applicationNumber",
            "loanAccountNumber",
            "reason",
            "employeeName",
            "Action",
          ];
          const resultList = JSON.parse(JSON.stringify(res));
          this.dataSourceDetail = new MatTableDataSource(resultList);
          this.dataSourceDetail.sort = this.sort;
          this.dataSourceDetail.paginator = this.paginator;
          console.log(this.dataSourceDetail);
        } else {
          this.dataSourceDetail = new MatTableDataSource([]);
          this.dataSourceDetail.sort = this.sort;
          this.dataSourceDetail.paginator = this.paginator;

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No Data Found",
            ...this.configSuccess,
          });
        }

        this.showSpinner = false;
      });
  }
  viewLoanDetail(row) {
    this.rowData = row;
    this.profilePicString = row.profilePicture;
    this.aadharFrontString = row.aadhaarFront;
    this.aadharBackString = row.aadhaarBack;
    this.panCardString = row.panCard;
    this.EmploymentProofDocumentString = row.employmentProofDocument;
    this.BankStatementString = row.bankStatement;
    this.salarySlipString = row.salarySlips;
    // profile pic
    console.log("profilepic", this.profilePicString);
    if (this.profilePicString) {
      if (Array.isArray(this.profilePicString)) {
        this.profileimageName = this.profilePicString[1];
        this.base64Contentprofileimage = this.profilePicString[0];
        console.log("Image Name:", this.profileimageName);
        console.log("base64 Name:", this.base64Contentprofileimage);
      } else {
        console.log("ProfilePicture is not a string or array");
      }
    } else {
      // Handle null or invalid ProfilePicture values
      console.log("No profile picture available");
    }
    // aadhar front
    if (this.aadharFrontString) {
      if (Array.isArray(this.aadharFrontString)) {
        this.aadharFrontImageName = this.aadharFrontString[1];
        this.base64ContentAadharFront = this.aadharFrontString[0];
        console.log("Aadhar Front Image Name:", this.aadharFrontImageName);
        console.log("Aadhar Front base64 Content:", this.base64ContentAadharFront);
      } else {
        console.log("AadharFront is not a string or array");
      }
    } else {
      // Handle null or invalid AadharFront values
      console.log("No Aadhar front image available");
    }
    // aadhar back
    if (this.aadharBackString) {
      if (Array.isArray(this.aadharBackString)) {
        this.aadharBackImageName = this.aadharBackString[1];
        this.base64ContentAadharBack = this.aadharBackString[0];
        console.log("Aadhar Back Image Name:", this.aadharBackImageName);
        console.log("Aadhar Back base64 Content:", this.base64ContentAadharBack);
      } else {
        console.log("AadharBack is not a string or array");
      }
    } else {
      console.log("No Aadhar back image available");
    }
    // pan card
    if (this.panCardString) {
      if (Array.isArray(this.panCardString)) {
        this.panCardImageName = this.panCardString[1];
        this.base64ContentPanCard = this.panCardString[0];
        console.log("Pan Card Image Name:", this.panCardImageName);
        console.log("Pan Card base64 Content:", this.base64ContentPanCard);
      } else {
        console.log("PanCard is not a string or array");
      }
    } else {
      console.log("No Pan card image available");
    }
    // EmploymentProofDocument
    if (this.EmploymentProofDocumentString) {
      if (Array.isArray(this.EmploymentProofDocumentString)) {
        this.EmploymentProofDocumentImageName = this.EmploymentProofDocumentString[1];
        this.base64ContentEmploymentProofDocument = this.EmploymentProofDocumentString[0];
        console.log("Employment Proof Document Image Name:", this.EmploymentProofDocumentImageName);
        console.log("Employment Proof Document base64 Content:", this.base64ContentEmploymentProofDocument);
      } else {
        console.log("EmploymentProofDocument is not a string or array");
      }
    } else {
      console.log("No Employment Proof Document image available");
    }
    // BankStatement
    if (this.BankStatementString) {
      if (Array.isArray(this.BankStatementString)) {
        this.BankStatementImageName = this.BankStatementString[1];
        this.base64ContentBankStatement = this.BankStatementString[0];
        console.log("Bank Statement Image Name:", this.BankStatementImageName);
        console.log("Bank Statement base64 Content:", this.base64ContentBankStatement);
      } else {
        console.log("BankStatement is not a string or array");
      }
    } else {
      console.log("No Bank Statement image available");
    }
    // Process salary slip data
    if (this.salarySlipString && Array.isArray(this.salarySlipString)) {
      this.salarySlipFiles = [];
      this.salarySlipNames = '';
      this.salarySlipString.forEach((slip, idx) => {
        if (Array.isArray(slip) && slip.length >= 2) {
          this.salarySlipFiles.push({
            salarybase64: slip[0],
            salaryfileName: slip[1]
          });
          this.salarySlipNames = this.salarySlipNames + ',' + slip[1];
          console.log(`Salary Slip ${idx + 1} - File Name:`, slip[1]);
          console.log(`Salary Slip ${idx + 1} - Base64 Content:`, slip[0]);
        } else if (typeof slip === "string") {
          this.salarySlipFiles.push({
            salarybase64: "",
            salaryfileName: slip
          });
          console.log(`Salary Slip ${idx + 1} - File Name:`, slip);
        }
      });
    } else {
      console.log("No Salary Slip data available or not an array");
    }
    this._QuickLoanService
      .Get_Customer_Exists_For_panNo_AdhaarNo({
        panNo: this.rowData.aadhaarNo,
        AdhaarNo: this.rowData.panNo,
      })
      .subscribe((res: any) => {
        console.log("response of pan aadhar api call", res);

        if (res.length > 0) {
          console.log("RES", res);

          this.dataSourceAadharPan = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );

          this.displayedColumnsPanAadhar = [
            "radio",
            "customerName",
            "Adhaarno",
            "PanNo",
            "Address",
          ];

          this.dataSourceAadharPan = this.dataSourceAadharPan.filteredData.map(
            (item) => ({
              ...item,
              isSelected: false,
            })
          );
          this.LoanProduct_Id = "4";
          this.Category = this.ProductList.find(
            (x) => x.ProductId == this.LoanProduct_Id
          )?.Category;
          var _find = this.dataSourceAadharPan.find(
            (x) => x.IsExists_Customer == 1
          );
          if (_find) {
            this.ExistLoan =
              "Sorry! This Customer Already Added To other Live Loan/ Application";
          } else {
            this.ExistLoan = "";
          }
          // console.log("DS after isSelected value", this.dataSourceAadharPan);
        } else {
          this.dataSourceAadharPan = null;
          this.LoanProduct_Id = "1";
          this.Category = this.ProductList.find(
            (x) => x.ProductId == this.LoanProduct_Id
          ).Category;
        }
      });

    this.NetFinance_Amt = row.loanAmount;
    this.customerId = "";
    console.log("Row Data", this.rowData);
    $("#loanInNeedModal").modal("show");
    $("#loanInNeedModal").css("z-index", "1050");
  }
  onClose() {
    $("#loanInNeedModal").modal("hide");
    this.showFinancialDetails = false;
    this.Branch_Id = "";
    this.LoanProduct_Id = "";
    this.SelectSourceArea = "";
    this.NetFinance_Amt = "";
    this.ROI = "";
    this.EMI_Type = "";
    this.No_Of_Inst = "";
    this.customerId = "";
  }
  getAreaByBranch(Branch_Id: string) {
    // Ensure Branch_Id is valid
    if (Branch_Id) {
      this.LmsService.Get_Lms_Area_ByBranch({ Branch_Id }).subscribe(
        (res: any) => {
          this.areaData = res;
          console.log("Area Data", this.areaData);
        }
      );
    }
  }
  resetInterstValue() {
    this.InterestAmount = null;
    this.AgreementAmount = null;
  }
  onRadioChange(row) {
    this.customerId = row.CustomerId;
    this.selectedRow = row;
    console.log("Selected row:", this.selectedRow);
  }
  onActionButtonClick() {
    if (this.selectedRow) {
      // Perform your action here based on the selected row
      console.log("Performing action on:", this.selectedRow);
    }
  }
  Calculate() {
    var ROI = parseFloat(this.ROI);
    var ROIInputMethod = this.ProductList.filter(
      (x) => x.ProductId == this.LoanProduct_Id
    )[0].ROI_Input_mathod;
    if (ROIInputMethod == "Daily") {
      ROI = ROI * this.currentUser.DaysInYear;
    }
    this.InterestAmount = Math.round(
      ((parseFloat(this.NetFinance_Amt) * ROI) /
        100 /
        this.currentUser.DaysInYear) *
      this.Days
    );
    this.AgreementAmount = Math.round(
      parseFloat(this.NetFinance_Amt) + parseFloat(this.InterestAmount)
    );
  }
  proceedLoan() {
    console.log("Proceed Loan clicked");

    this.showFinancialDetails = true;

    this.onActionButtonClick();
  }
  GetCollectionExecutive(value, productID) {
    this.LmsService.Get_Lms_CollectionExecutive({
      Branch_Id: value,
      ProductId: productID,
    }).subscribe((response) => {
      this.CollectionExecutiveData = response;
    });
  }
  GetSalesExecutive(value, productID) {
    this.losService
      .getEmployeeDropdown({
        BranchId: value,
        ProcessId: 1,
        ProductId: productID,
      })
      .subscribe((res: any) => {
        this.SalesExecutiveData = res;
        //this.Get_PartnerForDropdown();
      });
  }
  uploadDoc(customerid: any, docName: string, docData: string) {
    this.losService
      .UploadCustomerDoc({
        CustomerID: customerid,
        DocName: docName,
        DocData: docData,
      })
      .subscribe((res: any) => { });
  }
  uploadDocApplication(applicationNo: any, docName: string, docData: string) {
    this.losService.UploadCrcDoc({
      ApplicationNo: applicationNo,
      DocName: docName,
      DocData: docData,
    }).subscribe((res: any) => { });
  }
  SaveApplication() {
    const dob = new Date(this.rowData.dob);
    const formatted = this.datePipe.transform(dob, "yyyy-MM-dd");
    this.rowData.dob = formatted;
    var JSONdata = { ...this.rowData };
    delete JSONdata.profilePicture;
    delete JSONdata.aadhaarFront;
    delete JSONdata.aadhaarBack;
    delete JSONdata.panCard;
    delete JSONdata.employmentProofDocument;
    delete JSONdata.bankStatement;
    delete JSONdata.salarySlips;
    JSONdata.Branch_Id = this.Branch_Id;
    JSONdata.LoanProduct_Id = this.LoanProduct_Id;
    JSONdata.SelectSourceArea = this.SelectSourceArea;
    JSONdata.NetFinance_Amt = this.NetFinance_Amt;
    JSONdata.ROI = this.ROI;
    JSONdata.Loan_Date = new Date(this.Loan_Date);
    JSONdata.LoanMaturityDate = new Date(this.LoanMaturityDate);
    JSONdata.InterestAmount = this.InterestAmount;
    JSONdata.AgreementAmount = this.AgreementAmount;
    JSONdata.DaysDiff = this.Days;
    JSONdata.customerId = this.customerId;
    JSONdata.aadhaarFrontName = this.aadharFrontImageName;
    JSONdata.aadhaarBackName = this.aadharBackImageName;
    JSONdata.panCardName = this.panCardImageName;
    JSONdata.employmentProofDocumentName = this.EmploymentProofDocumentImageName;
    JSONdata.bankStatementName = this.BankStatementImageName;
    JSONdata.profilePictureName = this.profileimageName;
    JSONdata.salarySlipseName = this.salarySlipNames;
    console.log("json", JSON.stringify(JSONdata));
    this._QuickLoanService
      .QuickLoan_Proceed_LongFormWebsiteData({
        JSON: JSON.stringify(JSONdata),
        loginUserId: this.currentUser.userId,
      })
      .subscribe((result: any) => {
        if (result[0].CODE == 0) {
          if (this.customerId == "" || this.customerId == null || this.customerId == undefined) {
            this.uploadDoc(result[0].CustomerId, this.profileimageName, this.base64Contentprofileimage);
            this.uploadDoc(result[0].CustomerId, this.aadharFrontImageName, this.base64ContentAadharFront);
            this.uploadDoc(result[0].CustomerId, this.aadharBackImageName, this.base64ContentAadharBack);
            this.uploadDoc(result[0].CustomerId, this.panCardImageName, this.base64ContentPanCard);
          }
          if (this.EmploymentProofDocumentImageName) {
            this.uploadDocApplication(result[0].MSG, this.EmploymentProofDocumentImageName, this.base64ContentEmploymentProofDocument);
          }
          this.uploadDocApplication(result[0].MSG, this.BankStatementImageName, this.base64ContentBankStatement);
          this.salarySlipFiles.forEach((slip) => {
            this.uploadDocApplication(result[0].MSG, slip.salaryfileName, slip.salarybase64);
          });
          var request = {
            // employeeId: this.currentUser.userId.toString(),
            employeeName: this.currentUser.FullName,
            id: this.rowData.id,
            status: "IN_PROGRESS",
            reason: this.Reason,
            applicationNumber: result[0].MSG,
          };
          this._QuickLoanService
            .UpdateWebsiteLeads({ JSON: JSON.stringify(request) })

            .subscribe((res: any) => {
              console.log("Result of InProcess loan api call", res);

              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res.message,
                ...this.configSuccess,
              });
              this.showSpinner = false;
              this.getLongFormWebsiteData();
              this.onClose();

            });
        }
      });
  }

  rejectHoldLoan() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to ` + this.ReasonStatus + `?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult === false) {
          return;
        } else {
          this.showSpinner = true;
          var request = {
            employeeName: this.currentUser.FullName,
            id: this.ROW.id,
            status: this.ReasonStatus,
            reason: this.Reason,
          }
          this._QuickLoanService
            .UpdateWebsiteLeads({ JSON: JSON.stringify(request) })
            .subscribe((res: any) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res.message,
                ...this.configSuccess,
              });
              this.showSpinner = false;
              this.getLongFormWebsiteData();
              this.onClose();
              this.onCloseRejectHold();

            });
        }
      });
  }

  rejectHoldReasonModel(status, rowData) {
    this.ReasonStatus = status;
    this.ROW = rowData;
    $("#RejectHoldReason").modal("show");
    $("#RejectHoldReason").css("z-index", "1050");
  }
  onCloseRejectHold() {
    $("#RejectHoldReason").modal("hide");
    this.ReasonStatus = "";
    this.Reason = "";
  }
  exportTable() {
    if (this.exporter) {
      this.exporter.exportTable("xlsx", {
        fileName: "LongFormExportedData",
        sheet: "Sheet1",
      });
    }
  }
  applyFilter(filterValue: string) {
    this.dataSourceDetail.filter = filterValue.trim().toLowerCase();
  }
}
